'use client';
import classNames from 'classnames/bind';
import React, { forwardRef } from 'react';
import IcClose from '../icons/IcClose.mjs';
import TooltipCore from './TooltipCore.mjs';
import { TOOLTIP_BOX_VARIANT, TOOLTIP_ARROW_DIRECTION_MAP } from '../../constants/tooltip.mjs';
import { mergeRefs } from '../../utils/ref.mjs';
import styles from './TooltipBox.module.scss.mjs';

const cx = classNames.bind(styles);
const TooltipBoxContent = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    $arrow,
    id,
    variant,
    hasAnimation,
    bgColor,
    text,
    closeButton,
    arrowDirection,
    contentStyle,
    arrowStyle,
    isHideTransition,
    onTransitionEnd
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    className: cx('article', variant, bgColor && `bg-${bgColor}`, {
      animation: hasAnimation,
      hide: isHideTransition
    }),
    ref: ref,
    style: contentStyle,
    onTransitionEnd: onTransitionEnd
  }, /*#__PURE__*/React.createElement("span", {
    className: cx('text'),
    role: "tooltip",
    id: id
  }, text), variant === TOOLTIP_BOX_VARIANT.LONG && ( /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('close'),
    ...closeButton
  }, /*#__PURE__*/React.createElement(IcClose, {
    width: 18,
    height: 18,
    fill: "#929294"
  }), /*#__PURE__*/React.createElement("span", {
    className: cx('blind')
  }, "\uD234\uD301 \uB2EB\uAE30"))), /*#__PURE__*/React.createElement("span", {
    ref: $arrow,
    className: cx('icon-edge', arrowDirection),
    style: arrowStyle
  }));
});
TooltipBoxContent.displayName = 'TooltipBoxContent';
const TooltipBox = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    isShow,
    variant,
    hasAnimation = true,
    bgColor,
    text,
    closeButton,
    placement,
    tooltipPosition,
    arrowPosition = '50%',
    children,
    baseElement
  } = _ref2;
  const child = children && React.Children.only(children);
  if (!child && !baseElement) {
    return null;
  }
  return /*#__PURE__*/React.createElement(TooltipCore, {
    isShow: isShow,
    hasAnimation: hasAnimation,
    initialPlacement: placement,
    tooltipPosition: tooltipPosition,
    arrowPosition: arrowPosition,
    child: child,
    baseElement: baseElement,
    renderTooltipComponent: _ref3 => {
      let {
        $tooltip,
        $arrow,
        id,
        finalPlacement,
        contentStyle,
        arrowStyle,
        isHideTransition,
        onTransitionEnd
      } = _ref3;
      return /*#__PURE__*/React.createElement(TooltipBoxContent, {
        ref: mergeRefs([ref, $tooltip]),
        "$arrow": $arrow,
        id: id,
        variant: variant,
        hasAnimation: hasAnimation,
        bgColor: bgColor,
        text: text,
        closeButton: closeButton,
        arrowDirection: TOOLTIP_ARROW_DIRECTION_MAP[finalPlacement],
        contentStyle: contentStyle,
        arrowStyle: arrowStyle,
        isHideTransition: isHideTransition,
        onTransitionEnd: onTransitionEnd
      });
    }
  });
});
TooltipBox.displayName = 'TooltipBox';

export { TooltipBox as default };
